export const KEY_TOKEN = 'parcel_tracker_admin_token'
export const KEY_REFRESH_TOKEN = 'parcel_tracker_admin_refresh_token'
export const KEY_SERVER_ID = 'parcel_tracker_aserver_id'

export const KEY_USERNAME = 'parcel_tracker_current_user'
export const KEY_USER_ID = 'parcel_tracker_user_id'
export const KEY_BUILDING_IDS = 'parcel_tracker_building_ids'
export const KEY_ROLE = 'role'
